import { render } from "./ItemWasteCategory.vue?vue&type=template&id=227285fa"
import script from "./ItemWasteCategory.vue?vue&type=script&lang=js"
export * from "./ItemWasteCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__